// Generic client-side sort for a table whose full dataset is already loaded (no server paging) —
// pairs with components/SortableHeader.js. `getValue(row, key)` returns the raw comparable value
// for a column key (a string, number, or date-parseable string); null/undefined always sorts last
// regardless of direction, matching the convention already established in SalesTrendsPage.js.
export function sortRows(rows, sort, getValue) {
  if (!sort?.key) return rows;
  const dir = sort.dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const av = getValue(a, sort.key);
    const bv = getValue(b, sort.key);
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    if (typeof av === 'string' || typeof bv === 'string') {
      return dir * String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });
    }
    return dir * (av - bv);
  });
}

// Toggles direction on a repeat click of the same column, otherwise switches column with a
// sensible first-click direction (ascending for the given "text-like" keys, descending for
// everything else — numbers/dates read better biggest-or-most-recent-first on first click).
export function makeSortHandler(setSort, ascFirstKeys = []) {
  return (key) => {
    setSort(prev => {
      if (prev.key === key) return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
      return { key, dir: ascFirstKeys.includes(key) ? 'asc' : 'desc' };
    });
  };
}
